const makeUidPathWithParam = (path, uid, parameter, paramValue) =>
	path.replace(':uid', uid).replace(parameter, paramValue);

export default makeUidPathWithParam;
